import { render } from "./LeaveEntitlementTable.vue?vue&type=template&id=3329b965&scoped=true"
import script from "./LeaveEntitlementTable.vue?vue&type=script&lang=js"
export * from "./LeaveEntitlementTable.vue?vue&type=script&lang=js"

import "./LeaveEntitlementTable.vue?vue&type=style&index=0&id=3329b965&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3329b965"]])

export default __exports__